import dayjs from "dayjs";
import { TFunction } from "i18next";

import { Text } from "@pentabd/ui";
import { ProfileInfoCard, StatusBadge, ViewButton } from "@components";

import { MaintenanceType } from "@type/inventory/maintenance";
// import { useLanguage } from "@hooks/useLanguage";
import { EmployeeCommonInfoType } from "@type/HRM/employee-common-info";

export const MaintenanceTableColumn = (
  t: TFunction<"translation", undefined>,
) => {
  // const { language } = useLanguage();
  return [
    {
      id: 1,
      className: "text-nowrap",
      key: "category",
      name: t("INVENTORY_MAINTENANCE.TABLE.COLUMN.CATEGORY_GROUP"),
      render: (category: string, row: MaintenanceType) => {
        return (
          <>
            <Text color="subtitle2" className="text-nowrap" component="p">
              {category || "..."}
            </Text>
            <Text color="info" className="text-nowrap" component="p">
              {row.group || "..."}
            </Text>
          </>
        );
      },
    },
    {
      id: 2,
      key: "product",
      name: t("INVENTORY_MAINTENANCE.TABLE.COLUMN.NAME"),
      render: (product: string) => {
        return (
          <Text className="text-nowrap text-info" weight="semibold">
            {product || "..."}
          </Text>
        );
      },
    },
    {
      id: 3,
      className: "text-nowrap",
      key: "barcode",
      name: t("INVENTORY_MAINTENANCE.TABLE.COLUMN.BARCODE"),
      render: (barcode: number) => {
        return (
          <Text color="subtitle2" className="text-nowrap">
            {barcode || "..."}
          </Text>
        );
      },
    },
    {
      id: 4,
      className: "text-nowrap",
      key: "warrantyStartDate",
      name: t("INVENTORY_MAINTENANCE.TABLE.COLUMN.WARRANTY_START_END_DATE"),
      render: (warrantyStartDate: string, row: MaintenanceType) => (
        <Text color="subtitle2" className="text-nowrap" component="p">
          {warrantyStartDate
            ? dayjs(warrantyStartDate).format("DD-MM-YYYY")
            : "..."}
          &nbsp; -&nbsp;
          <span className="text-warning">
            {row.warrantyEndDate
              ? dayjs(row.warrantyEndDate).format("DD-MM-YYYY")
              : "..."}
          </span>
        </Text>
      ),
    },
    {
      id: 5,
      className: "text-nowrap",
      key: "vendor",
      name: t("INVENTORY_MAINTENANCE.TABLE.COLUMN.VENDOR"),
      render: (vendor: string) => (
        <Text color="subtitle2" className="text-nowrap">
          {vendor || "..."}
        </Text>
      ),
    },
    {
      id: 6,
      className: "text-nowrap",
      key: "issueNo",
      name: t("INVENTORY_MAINTENANCE.TABLE.COLUMN.ISSUE_NO"),
      render: (issueNo: number) => (
        <Text color="subtitle2" className="text-nowrap">
          {issueNo}
        </Text>
      ),
    },
    {
      id: 7,
      className: "text-nowrap",
      key: "status",
      name: t("INVENTORY_MAINTENANCE.TABLE.COLUMN.STATUS"),
      render: (status: string) => <StatusBadge status={status} />,
    },
    {
      id: 8,
      className: "text-nowrap",
      key: "createdByEmployee",
      name: t("INVENTORY_MAINTENANCE.TABLE.COLUMN.CREATED_EMPLOYEE"),
      render: (createdByEmployee: EmployeeCommonInfoType) => (
        <ProfileInfoCard employee={createdByEmployee} />
      ),
    },

    {
      id: 9,
      className: "text-nowrap",
      key: "assignedEmployee",
      name: t("INVENTORY_MAINTENANCE.TABLE.COLUMN.ASSIGNED_EMPLOYEE"),
      render: (assignedEmployee: EmployeeCommonInfoType) => {
        return assignedEmployee !== null ? (
          <ProfileInfoCard employee={assignedEmployee as any} />
        ) : (
          <></>
        );
      },
    },
    {
      id: 10,
      key: "id",
      name: "",
      render: (id: number | string) => {
        return <ViewButton link={`${id}`} />;
      },
    },
  ];
};
